module.exports = __webpack_public_path__ + "static/img/53-3.d951cd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/53-3.jpg
// module id = +pzo
// module chunks = 0